import { FlexBox, Text, SocialLink, SocialLinks } from '@fable/components'
import { useImageColor } from '@fable/hooks'
import { css, useTheme } from '@fable/theme'
import ShareButton from 'components/share_button/ShareButton'
import { PersonImage } from './PersonImage'
import { BackButton } from './BackButton'

interface Props {
  name: string
  image: string | null
  role?: string
  hideShareButton: boolean
  socialLinks?: SocialLink[]
}

export const PersonCard = ({
  name,
  image,
  role,
  hideShareButton,
  socialLinks,
}: Props) => {
  const { colors, mediaQueries, motion } = useTheme()
  const defaultTheme = !image || !image.length
  const color = useImageColor(image as string)
  const backgroundColor = defaultTheme ? colors.uiPearlExtraLight : color
  const textColor = defaultTheme ? colors.uiGraphite : colors.uiWhite

  return (
    <FlexBox
      className={css`
        position: relative;
        padding: 80px 24px 48px;
        background-color: ${backgroundColor};
        gap: 24px;
        ${motion.transition('background-color')};
        ${mediaQueries.mobileL} {
          border-radius: 12px 72px 12px 72px;
        }
        ${mediaQueries.tabletL} {
          width: 50%;
          height: calc(100% - 32px);
          gap: 40px;
        }
      `}
      flexDirection="column"
      alignItems="center"
      centerAll
    >
      <BackButton />
      <PersonImage image={image} name={name} />
      <FlexBox flexDirection="column" alignItems="center" gap="8px">
        <Text
          className="author-name"
          type="header"
          sizing={{ base: 'M', mobileL: 'L' }}
          color={textColor}
          align="center"
        >
          {name}
        </Text>
        {!!role ? (
          <Text
            data-testid="person-card-role"
            type="label"
            sizing="L"
            color={textColor}
            align="center"
          >
            {role}
          </Text>
        ) : null}
      </FlexBox>
      {hideShareButton ? null : <ShareButton category="author" />}
      {!socialLinks || !socialLinks?.length ? null : (
        <SocialLinks links={socialLinks} backgroundColor={colors.uiWhite} />
      )}
    </FlexBox>
  )
}
